import { AccessTypes } from 'modules/core/domain/interfaces/supabase/overlay/auxiliary-types';

/**
 * Owner to send when a template is saved from «Редактировать» (`Overlay.updateTemplate` writes `owner_id: null` for
 * `default` itself).
 *
 * A shared catalog template (no owner — imported by a super-admin, IMGM-1589) stays shared while it is `public`:
 * `undefined` leaves `owner_id` as is, otherwise the save would hand it to the organization the super-admin happens
 * to be in. Made `private`, it has to belong to someone — the current organization, as before.
 */
export function editedTemplateOwnerId(
  currentOwnerId: number | null | undefined,
  access: AccessTypes | undefined,
  organizationId: number,
): number | undefined {
  if (currentOwnerId !== null && currentOwnerId !== undefined) return organizationId;
  return access === 'private' ? organizationId : undefined;
}
